import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ProductDiscount,
  ProductDiscountService,
} from 'src/app/services/product-discount/product-discount.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-delete-product-discount-dialog',
  templateUrl: './delete-product-discount-dialog.component.html',
  styleUrls: ['./delete-product-discount-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent],
})
export class DeleteProductDiscountDialogComponent {
  private ref =
    inject<MatDialogRef<DeleteProductDiscountDialogComponent>>(MatDialogRef);
  private productDiscountService = inject(ProductDiscountService);
  productDiscount = inject<ProductDiscount>(MAT_DIALOG_DATA);

  submitLoading = false;

  async submit(): Promise<void> {
    if (this.submitLoading) {
      return;
    }

    try {
      this.submitLoading = true;

      await this.productDiscountService.deleteProductDiscount(
        this.productDiscount.id,
      );

      this.ref.close(true);
    } catch (error) {
      console.error('Error while saving product discount', error);
    } finally {
      this.submitLoading = false;
    }
  }

  cancel(): void {
    this.ref.close();
  }
}
